<template>
  <div
    style="margin-top: 10px;"
    class="fill-topic topic-box"
    @mouseleave="showTopicEditorBox = false"
    @mouseenter="handleMouseEnter"
  >
    <div
      class="topic-bd fill-cont non-answer-area"
      :class="`${msg.hasTitle ? 'choose-cont-hastitle' : ''}`"
      :style="{
        height: (msg.initDragHeight || 300) + 'px',
        border: showTopicEditorBox ? '1px solid #409eff !important' : '',
      }"
    >
      <template v-if="!isPreview">
      <TopicEditBox
        v-if="showTopicEditorBox"
        position="top:5px"
        :isEdit="false"
        :msg="msg"
      ></TopicEditBox>
      <div class="drag_mark" v-show="showTopicEditorBox"></div>

      <div 
        v-html="msg.innerHTML"
        class="non-answer-cont"
        :style="{
            height: (msg.initDragHeight || 100)-2 + 'px',
            '--font-size': getFontSize + 'px'
        }"
      ></div>
      </template>
      <template v-if="isPreview">
        <div
          class="non-answer-cont"
          :style="{
            height: (msg.initDragHeight || 100)-2 + 'px',
            '--font-size': getFontSize + 'px'
          }"
          v-html="html"
        ></div>
      </template>
    </div>
    <div class="drag_button" id="drag_button" v-show="showTopicEditorBox">
      <i class="el-icon-rank" style="font-size: 22px"></i>
    </div>
  </div>
  <!--主体-->
</template>

<script>
import { mapGetters, mapState, mapMutations } from "vuex";
import { mouseEventMixins } from "../../mixins/mouseEvent.mixins";
import { editScoreBoxMixins } from "../../mixins/editScoreBox.mixins";
import FillTopic from "@/assets/js/utils/FillTopic";
import MyDrag from "@/assets/js/utils/base/MyDrag";
import { TAG_P_HEIGHT } from "@/subjects/constant";
export default {
  name: "fillTopic",
  props: {
    msg: { innerHTML: "" },
    isPreview: Boolean,
  },
  mixins: [mouseEventMixins, editScoreBoxMixins],
  components: {},
  computed: {
    ...mapState("card", {
      answerSignal: (state) => state.answerSignal,
      existHeight: (state) => state.existHeight,
      pageCell: (state) => state.pageCell,
      subjects: (state) => state.subjects,
      currentPageNum: (state) => state.currentPageNum,
      newTopicHeight: (state) => state.newTopicHeight,
    }),
    ...mapGetters({
      answerSheet: "answerPanel/answerSheet",
    }),
    rowNum() {
      if (this.msg.typesItem.rowNum < 1) {
        return this.msg.typesItem.rowNum.toString().split(".");
      } else {
        return [this.msg.typesItem.rowNum];
      }
    },
    html: function () {
      console.log("mounted:::this.msg:",this.msg);
      return this.msg.innerHTML
    },
    getFontSize() {
      const height = this.msg.initDragHeight || 100;
      if (height < 150) return 18;
      if (height < 200) return 24;
      if (height < 300) return 36;
      if (height < 400) return 46;
      if (height < 500) return 56;
      return 56;
    },
  },

  data(ctx) {
    return {
      showTopicEditorBox: false,
      myFillTopic: undefined,
      myDrag: undefined,
      editor: ctx.$ckEditor,
      canFillHeight: 0,
    };
  },
  created() {},
  mounted() {
    const canFillHeight = this.pageCell[this.currentPageNum]?.canFillHeight || 0;
    const target = document.querySelectorAll(".topic-bd");
    this.myDrag = new MyDrag(target,canFillHeight);
    this.myFillTopic = new FillTopic({
      width: 1107,
      height: 706,
      canDrag: true,
      myDrag: this.myDrag,
    });
    this.myFillTopic.init();
  },
  methods: {
    ...mapMutations({
      setAnswerSignal: "card/setAnswerSignal",
      setCurrentPageNum: "card/setCurrentPageNum",
      updatePageCell: "card/updatePageCell",
      updateSubjects: "card/updateSubjects",
    }),
    async handleBlur(data) {
      const { editorHeight, content, overstepDistance } = data;
      this.setCurrentPageNum(this.msg.pageIndex);
      await this.updatePageCell({
        currentIndexInPage: this.msg.currentIndexInPage,
        initDragHeight: editorHeight,
        innerHTML: content,
      });
      //this.deconstruction();
      const timer = setTimeout(() => {
        overstepDistance > 0 &&
          this.myFillTopic.updateViewHeight(
            overstepDistance,
            undefined,
            undefined,
            "blur"
          );
        clearTimeout(timer);
      }, 200);
    },
    handleMouseDown() {},
  },
  watch: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="scss">
.choose-cont .ck-content p {
  // margin-top: 10px !important;
}
// .choose-cont .ck-content.ck-editor__editable_inline > :first-child {
//   margin-top: 35px !important;
// }
.topic-desc {
  margin: 10px 0 35px;
  position: relative;
  top: 0;
  left: 15px;
  .th-item {
    display: inline-block;
    margin-right: 8px;
  }
  .th-fill {
    display: inline-block;
    width: 16px;
    height: 8px;
    border: 1px solid #000;
    margin-left: 3px;
  }
}
</style>
